import React , { Component } from 'react';

export class Svg extends Component{
  render(){
    return(
      <svg viewBox='0 0 24 24' {...this.props}/>
    )
  }
}